var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ProhibitInset"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.2143 8.2857C9.33758 8.40899 9.40684 8.5762 9.40684 8.75055C9.40684 8.9249 9.33758 9.09211 9.2143 9.21539C9.09102 9.33867 8.92381 9.40794 8.74946 9.40794C8.57511 9.40794 8.4079 9.33867 8.28461 9.21539L4.78461 5.71539C4.66133 5.59211 4.59207 5.4249 4.59207 5.25055C4.59207 5.0762 4.66133 4.90899 4.78461 4.7857C4.9079 4.66242 5.07511 4.59316 5.24946 4.59316C5.42381 4.59316 5.59101 4.66242 5.7143 4.7857L9.2143 8.2857ZM12.9063 7C12.9063 8.16815 12.5599 9.31006 11.9109 10.2813C11.2619 11.2526 10.3395 12.0096 9.26023 12.4567C8.181 12.9037 6.99345 13.0207 5.84775 12.7928C4.70205 12.5649 3.64966 12.0024 2.82365 11.1763C1.99765 10.3503 1.43513 9.29795 1.20724 8.15225C0.979346 7.00655 1.09631 5.819 1.54334 4.73978C1.99037 3.66055 2.74739 2.73812 3.71867 2.08913C4.68994 1.44015 5.83186 1.09375 7 1.09375C8.5659 1.09549 10.0672 1.71831 11.1744 2.82557C12.2817 3.93283 12.9045 5.4341 12.9063 7ZM11.5938 7C11.5938 6.09144 11.3243 5.20329 10.8196 4.44785C10.3148 3.69241 9.59735 3.10362 8.75795 2.75593C7.91856 2.40824 6.99491 2.31727 6.10381 2.49452C5.21271 2.67177 4.39418 3.10928 3.75173 3.75173C3.10928 4.39418 2.67177 5.2127 2.49452 6.1038C2.31727 6.9949 2.40824 7.91855 2.75593 8.75795C3.10362 9.59735 3.69241 10.3148 4.44785 10.8196C5.20329 11.3243 6.09144 11.5938 7 11.5938C8.21794 11.5924 9.38562 11.108 10.2468 10.2468C11.108 9.38562 11.5924 8.21794 11.5938 7Z",
    fill: "black",
    fillOpacity: 0.45
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoved);
export default __webpack_public_path__ + "static/media/Removed.04f5f21c.svg";
export { ForwardRef as ReactComponent };